var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12774_42597)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.29633 0.265625C2.99136 0.265625 0.265625 2.99136 0.265625 6.29633V33.7086C0.265625 37.0136 2.99136 39.7393 6.29633 39.7393H33.7086C37.0136 39.7393 39.7393 37.0136 39.7393 33.7086V6.29633C39.7393 2.99136 37.0136 0.265625 33.7086 0.265625H6.29633ZM29.8709 7.17438C31.6911 7.17438 33.1604 8.64368 33.1604 10.4639C33.1604 12.284 31.6911 13.7533 29.8709 13.7533C28.0507 13.7533 26.5814 12.284 26.5814 10.4639C26.5814 8.64368 28.0507 7.17438 29.8709 7.17438ZM11.2305 21.8185C11.7952 21.8185 12.362 22.0291 12.7896 22.4567L20.6364 30.3335C21.4916 31.1887 22.8993 31.1887 23.7545 30.3335C24.6098 29.4782 24.6098 28.0706 23.7545 27.2153L20.9234 24.3884L22.8294 22.4567C23.7066 21.6015 25.0922 21.6015 25.9475 22.4567L35.3533 31.8668V33.7086C35.3533 34.6405 34.6405 35.3533 33.7086 35.3533H6.29633C5.36445 35.3533 4.65159 34.6405 4.65159 33.7086V27.4809L9.67146 22.4567C10.0991 22.0291 10.6658 21.8185 11.2305 21.8185Z",
    fill: "#29CC8B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12774_42597"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageIcon);
export default __webpack_public_path__ + "static/media/Image-Icon.9d217f5df22919e670c68fb1c8bcc149.svg";
export { ForwardRef as ReactComponent };